import { baseFetch } from "./base";

export const getRealtimeSpeechMenu = async () => {
  try {
    const response = await baseFetch.get("/realtime_menu");

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(
        "Error while fething realtime speech menu options:",
        error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getPersonaMenu = async () => {
  try {
    const response = await baseFetch.get("/realtime_persona_menu");

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(
        "Error while fething realtime persona menu options:",
        error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getLevelsMenu = async () => {
  try {
    const response = await baseFetch.get("/realtime_maturity_levels_menu");

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(
        "Error while fething realtime maturity level menu options:",
        error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getRealtimeDialogs = async () => {
  try {
    const response = await baseFetch.get("/realtime_dialogs");

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error(
        "Error while sending fething realtime dialogs:",
        error.message
      );
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getRealtimeReport = async (report_id: string) => {
  try {
    const response = await baseFetch.get("/realtime-report", {
      params: { report_id },
    });

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error("Error while fething realtime report:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const getRealtimeStatistics = async () => {
  try {
    const response = await baseFetch.get("/realtime_stat");

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error("Error while fething realtime report:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const sendRecordingEvent = async (
  event: "start" | "discard" | "recording",
  timeFromStart: number = 0
) => {
  try {
    const response = await baseFetch.post("/recording_audio", {
      time_from_start: timeFromStart,
      event,
    });

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error("Error while sending recording event:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};

export const sendRecordingStartEvent = async () => {
  return sendRecordingEvent("start", 0);
};

export const postRealtimeMenu = async (data: Record<string, any> = {}) => {
  try {
    const response = await baseFetch.post("/realtime/menu", data);

    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      console.error("Error while posting realtime menu:", error.message);
    } else {
      console.error("Unexpected error:", error);
    }
    throw error;
  }
};
